import React, { useState } from 'react';
import { ExternalLink, Image as ImageIcon } from 'lucide-react';
import HtmlEmail from './HtmlEmail';

// Keep email HTML inert. Only explicit HTTP(S) URLs become links, never embeds.
function readableLinks(paragraph) {
  return paragraph.split(/(\[https?:\/\/[^\s<>\]]+\]|https?:\/\/[^\s<>[\]"']+)/gi).map((part, index) => {
    const address = part.startsWith('[') && part.endsWith(']') ? part.slice(1, -1) : part;
    if (!/^https?:\/\//i.test(address)) return part;
    let url;
    try { url = new URL(address); } catch (_) { return part; }
    if (!['http:', 'https:'].includes(url.protocol)) return part;
    const image = /\.(png|jpe?g|gif|webp|svg|avif)$/i.test(url.pathname);
    const Icon = image ? ImageIcon : ExternalLink;
    return <a key={index} href={address} target="_blank" rel="noopener noreferrer" title={address}
      className="email-body-link" aria-label={`${image ? 'View image' : 'Open link'} on ${url.hostname} (opens in a new tab)`}>
      <Icon aria-hidden="true" className="h-3.5 w-3.5 shrink-0" /><span>{image ? 'View image' : 'Open link'}<span className="email-link-host"> · {url.hostname}</span></span>
    </a>;
  });
}

export default function EmailBody({ text, html, plain: controlledPlain, hideControls = false }) {
  const [localPlain, setPlain] = useState(false);
  const plain = controlledPlain ?? localPlain;
  const readable = (text || '').replace(/\r\n?/g, '\n').replace(/^[ \t]+$/gm, '').replace(/\n{3,}/g, '\n\n').trim();
  if (html) return <div className="border-t border-gray-100 pt-3">
    {!hideControls && <div className="mb-3 flex justify-end"><button type="button" className="rounded px-2 py-1 text-xs text-gray-500 hover:bg-gray-100" onClick={() => setPlain(value => !value)}>{plain ? 'Formatted email' : 'Plain text'}</button></div>}
    {plain ? <EmailBody text={text} /> : <HtmlEmail html={html} />}
  </div>;
  return <div className="email-readable-body border-t border-gray-100 pt-4 text-sm text-gray-800">
    {readable ? readable.split('\n\n').map((paragraph, index) => /^[=_-]{5,}$/.test(paragraph.trim())
      ? <hr key={index} className="my-4 border-gray-200" />
      : <p key={index} className="whitespace-pre-wrap break-words">{readableLinks(paragraph)}</p>)
      : <p className="text-gray-500">This email has no text content.</p>}
  </div>;
}
